export default "/_next/static/images/d0826a6e541f90ac27c838618d019f00.png";